import React from 'react'
import { Modal, Button } from 'antd'
import styled from 'styled-components'

type ConfirmDeleteMessageModalProps = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

const ConfirmDeleteMessageModal: React.FC<ConfirmDeleteMessageModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal
      open={isOpen}
      centered
      closable={false}
      footer={null}
      className="confirm-delete-modal"
    >
      <Wrapper>
        <h2>メッセージを削除する確認</h2>
        <p>
          このメッセージを削除すると元に戻れません。
          <br />
          本当に削除しますか？
        </p>
        <ButtonGroup>
          <CancelButton onClick={onClose}>キャンセル</CancelButton>
          <ConfirmButton onClick={onConfirm}>はい</ConfirmButton>
        </ButtonGroup>
      </Wrapper>
    </Modal>
  )
}

export default ConfirmDeleteMessageModal

const Wrapper = styled.div`
  text-align: center;
  h2 {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 24px;
  }
  p {
    font-size: 16px;
    margin-bottom: 32px;
    color: #4a5568;
  }
`

const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
`

const CancelButton = styled(Button)`
  background-color: #6c757d;
  color: white;
  border: none;
  padding: 0 24px;
  height: 40px;
  font-size: 16px;
  &:hover {
    background-color: #5a6268;
  }
`

const ConfirmButton = styled(Button)`
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 0 24px;
  height: 40px;
  font-size: 16px;
  &:hover {
    background-color: #c82333;
  }
`
